import { BaseError } from "./BaseError";

export class InternalServerError extends BaseError {
  readonly status = 500;
}
